import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { firstValueFrom, take } from "rxjs";
import { RoleHelper } from "./static-classes/role-helper";
import { UserService } from "./user.service";
import { FeatureService } from "./feature.service";

export const canActivateWorkflowsRoute: CanActivateFn = async () => {
    const router = inject(Router);
    const userService = inject(UserService);
    const featureService = inject(FeatureService);

    await firstValueFrom(userService.userStream.pipe(take(1)));
    await featureService.initializeFeatureFlags();

    if (userService.hasRole(RoleHelper.ROLE_EDITOR)) {
        return true;
    }

    return router.parseUrl('/search-map');
};
